// Informational reference shown alongside the truck maximum settings — industry rules of thumb, not
// regulatory limits, and never used in any calculation. Keyed by the same lowercase truck types as
// enums/truck-type, then by maximum mode ('weight' | 'pallets').
// TODO: replace with the exact figures from the designs.
export default {
  dry: { weight: '44,000 - 45,000', pallets: '26 (52 double stacked)' },
  refrigerated: { weight: '42,000 - 44,000', pallets: '24-25' },
  frozen: { weight: '42,000 - 44,000', pallets: '24-25' },
};
